import React from 'react';

import { CASE_LOCK_BANNER_HEIGHT_PX } from './constants';
import styles from './styles.module.scss';

export { CASE_LOCK_BANNER_HEIGHT_PX };

export const CaseLockBanner = ({ message }: { message: string }) => {
  return (
    <div
      className={styles.LockBanner}
      role="status"
      aria-live="polite"
      data-testid="case-lock-banner"
    >
      <div className={styles.LockBannerIcon} aria-hidden="true">
        <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect
            x="3"
            y="7"
            width="10"
            height="7"
            rx="1.5"
            stroke="currentColor"
            strokeWidth="1.3"
          />
          <path
            d="M5 7V5a3 3 0 016 0v2"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
          <circle cx="8" cy="10.5" r="1" fill="currentColor" />
        </svg>
      </div>
      <span className={styles.LockBannerText}>{message}</span>
    </div>
  );
};
